module.exports = __webpack_public_path__ + "img/banner.0a47ce66.jpg";